import { render, staticRenderFns } from "./CampaignTweetPostDialog.vue?vue&type=template&id=22c0895a&scoped=true"
import script from "./CampaignTweetPostDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignTweetPostDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignTweetPostDialog.vue?vue&type=style&index=0&id=22c0895a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0895a",
  null
  
)

export default component.exports